module.exports = __webpack_public_path__ + "img/1716350247812-WhatsApp Image 2024-05-22 at 10.38.21.jpeg.e9b10eba.webp";